import { Component, EventEmitter, Input, OnInit, Output, ViewChild, inject } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { InLineErrorMessages } from '../../_shared/constants/error-messages.constant';
import { ErrorHandlerService } from '../../_shared/services/error-handler.service';
import { AuthService } from '../../_shared/services/auth.service';
import { LoginService } from '../../_shared/services/login.service';
import { Response } from '../../_shared/models';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { LoginCredentials } from '../../_shared/models/login-credentials.model';

@Component({
  selector: 'app-login-form',
  standalone: true,
  imports: [
    FormsModule,
    TranslocoModule
  ],
  templateUrl: './login-form.component.html',
  styleUrl: './login-form.component.scss'
})
export class LoginFormComponent implements OnInit {
  private readonly transloco = inject(TranslocoService);
  private readonly errorHandler = inject(ErrorHandlerService);
  @BlockUI() blockUI!: NgBlockUI;
  @ViewChild('loginForm') loginForm!: NgForm;
  @Output() toggleForgotPasswordForm: EventEmitter<any> = new EventEmitter<any>();
  @Input() inlineErrorMessage: string;

  isLoggingIn: boolean = false;
  showUserPassword: boolean = false;
  formSubmitted: boolean = false;
  user: LoginCredentials = {
    username:'',
    password: '',
  }
  // inlineErrorMessage: string;
  authStateSubscription: Subscription;

  constructor(
    private authService: AuthService,
    private loginService: LoginService,
    private toastr: ToastrService
  ) { }
  
  ngOnInit(): void {
  }

  public isFormValid(): boolean {
    return !!this.user.username && !!this.user.password;
  }

  public login(): void {
    this.formSubmitted = true;
    this.inlineErrorMessage = '';
    
    this.blockUI.start();
    if (!this.loginForm.valid) {
      this.blockUI.stop();
      return;
    }
  
    this.loginService.login(this.user).subscribe({
      next: (response: Response<string>) => {
        this.blockUI.start(this.transloco.translate('common.loading'));
        this.authService.setUser(response.data!);
        this.authService.redirectUrl = '/authenticate'
        this.authService.redirect();
      },
      error: (error:any) => {
        this.handleError(error)
        this.blockUI.stop();
      }
    });
  }

  showPassword(): void {
    this.showUserPassword = !this.showUserPassword;
  }

  toggleForgotPassword(): void {
    this.toggleForgotPasswordForm.emit(true);
  }

  private handleError(error: any): void {
    const code = error?.error?.errorCode;
    this.inlineErrorMessage = InLineErrorMessages[code] ? this.transloco.translate(`inlineErrorMessages.${code}`) : '';
    if (!this.inlineErrorMessage) {
      const message = this.errorHandler.getMessage(code) || this.transloco.translate('login.loginError');
      this.toastr.error(message);
    }
  }
}